module.exports = __webpack_public_path__ + "static/media/Vitality_100x72.4c6b7d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/OptIn/logos/Vitality_100x72.png
// module id = 885
// module chunks = 0